import axios from 'axios'
const baseUrl = process.env.REACT_APP_API_BASEURL

/**
* @function getBreakdownESGService
* @param { token }
* @description This function is used to get data
*/
export const getBreakdownESGService = async ({ token }) => {
    const result = axios.get(`${baseUrl}users/get/indicator/performance`, {
        headers: {
            Authorization: `Bearer ${token}`,
        }
    })
    return result;
};


/**
* @function filterBreakdownESGIndustryAndStateService
* @param { token, country, state, industry, toDate, fromDate}
* @description This function is used to get industry maturity data
*/
export const filterBreakdownESGIndustryAndStateService = async ({ token, country, state, industry, toDate, fromDate }) => {
    const result = axios.get(`${baseUrl}users/get/indicator/performance?country=${country}&state=${state}&industry=${industry}&toDate=${toDate}&fromDate=${fromDate}`, {
        headers: {
            Authorization: `Bearer ${token}`,
        }
    })
    return result;
};